module.exports = __webpack_public_path__ + "static/media/healthy_habit.d0a2301f.svg";